import React, { useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Inputs
import { TextInputField, DropDownField, Button } from '../helpers';

// utils
import { validateInputs } from '../utils'

// ValidationSchema
import { ShippingAddrValidationSchema, shippingAddressInitialState } from '../validation/addShippingAddrValidation';

// redux
import { raiseToast } from '../services/redux/reducers/toast/toast';
import { getPMCompanyConfig } from '../setup/pmCompanyConfig';


const AddShippingAddress = (props) => {

    const dispatch = useDispatch()

    const { stateList } = props

    const { countriesData, pinCodesData } = props
    const [shippingAddrInputs, setShippingAddrInputs] = useState(JSON.parse(JSON.stringify(shippingAddressInitialState)))
    const [formErrors, setFormErrors] = useState([])

    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const handleSubmitShippingAddr = async () => {
        const validation_res = await validateInputs(ShippingAddrValidationSchema, shippingAddrInputs, pmCompanyConfig)
        console.log("validation-response", validation_res)
        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
            }
            else {
                setFormErrors({})
                const shippingAddressInitialState = {
                    address: '',
                    stateId: null,
                    city: '',
                    pinCode: '',
                    countryId: null
                }
                
                setShippingAddrInputs({ ...shippingAddressInitialState })
                props.handleSubmit(validation_res.result)
            }
        }
    }

    const handleShippingAddrInputChange = (event) => {
        shippingAddrInputs[event.target.name] = event.target.value

        if (event.target.name === "pinCode" && (event.target.value).length === pmCompanyConfig.pinCodeLength) {
            const relatedPinCode = pinCodesData?.find(eachPincode => {
                if (eachPincode.pinCode === parseInt(event.target.value)) {
                    return eachPincode
                }
            })

            if (relatedPinCode?.stateId || pmCompanyConfig.isInternational) {
                if (!pmCompanyConfig.isInternational){
                    const relatedState = stateList.find(eachState => {
                        if (eachState.stateId === relatedPinCode.stateId) {
                            shippingAddrInputs["stateId"] = eachState?.stateId
                            return eachState
                        }
                    })

                    countriesData.find(eachCountry => {
                        if (eachCountry.countryId === relatedState.countryId) {
                            shippingAddrInputs["countryId"] = eachCountry.countryId
                        }
                    })
                } else{
                    shippingAddrInputs["stateId"] = pmCompanyConfig.defaultStateId
                    shippingAddrInputs["countryId"] = pmCompanyConfig.defaultCountryId
                }
            } else {
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter valid pincode", life: 3000 }))
            }
        } else {
            if (event.target.name === "pinCode") {
                shippingAddrInputs["stateId"] = ""
                shippingAddrInputs["countryId"] = ""
            }
        }
        setShippingAddrInputs({ ...shippingAddrInputs })
    }
    console.log("shippingAddrInputs", shippingAddrInputs)
    return (
        <div className="">
            <div className="grid">
                <div className="flex flex-column col-12 md:col-12">
                    <TextInputField name="address" labelText="Address Line" value={shippingAddrInputs.address} maxLength={400} errorMessage={formErrors.address} onChange={(event) => handleShippingAddrInputChange(event)} />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <TextInputField name="city" labelText="City" value={shippingAddrInputs.city} maxLength={40} onChange={(event) => handleShippingAddrInputChange(event)} errorMessage={formErrors.city} />
                </div>
                <div className="flex flex-column col-12 md:col-4">
                    <TextInputField name="pinCode" keyfilter={"pint"} labelText="PinCode" value={shippingAddrInputs.pinCode} onChange={(event) => handleShippingAddrInputChange(event)} errorMessage={formErrors.pinCode} maxLength={6} />
                </div>
                {
                    pmCompanyConfig.isInternational ?
                    null 
                    :
                    <>
                        <div className="flex flex-column col-12 md:col-4">
                            <DropDownField name="stateId" labelText="State" options={stateList} optionLabel="stateName" optionValue="stateId" value={shippingAddrInputs.stateId} onChange={(event) => handleShippingAddrInputChange(event)} errorMessage={formErrors.stateId} disabled />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <DropDownField name="countryId" labelText="Country" options={countriesData} optionLabel="countryName" optionValue="countryId" value={shippingAddrInputs.countryId} onChange={(event) => handleShippingAddrInputChange(event)} errorMessage={formErrors.countryId} disabled />
                        </div>
                    </>
                }
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button label="Add Shipping Address" onClick={(event) => handleSubmitShippingAddr(event)} />
            </div>
        </div>
    );
};

export default AddShippingAddress;